import styled from "styled-components";


export const Footer = styled.div `
    font-size: small;
    border: 1px solid darkcyan; /*lightsalmon;*/
    background-image: linear-gradient(white, LightSeaGreen);
    
    position: fixed;
    margin-top: 7em;
    padding: .6em;
    bottom: 0;
    left: 0;
    right: 0;

    ul {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
    }
`

export const AppLogin = styled.div `
    margin-top: 1em;
    height: 200px;
`

export const App = styled.div `
  text-align: center;
`

export const Hander = styled.div `
  margin-top: 0.5em;
  margin-bottom: 1em;
  border: 2px solid darkcyan;
  background-image: linear-gradient(LightSeaGreen, white);
  padding: 0.2em;
  text-align: center;
`

export const MainMenue = styled.div `
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    width: max-content;
    margin: 0 auto; 
    text-decoration: underline;
`

export const ButtonCollection = styled.div `
    display: flex;
    justify-content: center;
    border-radius: 10px;
    background-color: rgba(32, 178, 171, 0.2);
`

export const ButtonHauptmenü = styled.button `
    width: 11em;
    height: 7em;
    border-radius: 10px;
    border: 1px solid darkcyan;
    font-size: large;
    margin: 0.5em 1em;

    &:hover {
    text-decoration: underline;
    background-color: lightseagreen;
}
`